import { Grid } from '@material-ui/core';
import React, { useState } from 'react';
import {
  DailySummaryDto,
  TriggerDTO,
} from '@peartherapeutics/hylia-api-client';
import { useSimulatorRoutes } from 'hooks';
import TriggerChart from '../../TriggerChart';
import { getAverageTriggers, getFormattedTriggers } from '../../utils';
import { BlockBottom, BlockMiddleEmpty, BlockTop } from '../Widgets/Blocks';
import WidgetWrapper from '../Widgets/WidgetWrapper';
import CravingChart from './CravingChart';
import styles from './styles.module.scss';

interface IWidgetSubstanceUseProps {
  bottomLink?: string;
  total: number;
  subtitle: string;
  isProcessing: boolean;
  isEmptySubstanceUse: boolean;
  showBupUseLabels: boolean;
  dailySummaries: DailySummaryDto[];
  timezone: string;
}

const WidgetSubstanceUse = (props: IWidgetSubstanceUseProps) => {
  const {
    total,
    subtitle,
    isProcessing,
    isEmptySubstanceUse,
    showBupUseLabels,
    dailySummaries,
    timezone,
  } = props;
  const routes = useSimulatorRoutes();
  const title = isProcessing ? '' : `${total}`;

  const [triggersArray, setTriggersArray] = useState<TriggerDTO[]>(
    getAverageTriggers(dailySummaries),
  );

  const onHoverCraving = (triggers: TriggerDTO[]) => {
    setTriggersArray(getFormattedTriggers(triggers));
  };

  const onLeaveCraving = () => {
    setTriggersArray(getAverageTriggers(dailySummaries));
  };

  return (
    <WidgetWrapper
      externalClasses={styles.wrapper}
      testId="widget-substance-use"
      ariaLabel="Substance Use & Craving Chart"
    >
      <div data-testid="widget-substance-use-top">
        <BlockTop title={title} subtitle={subtitle} />
      </div>
      {isEmptySubstanceUse ? (
        <BlockMiddleEmpty
          externalClasses={styles.substance}
          content="Self-reported drug use, cravings and triggers will be displayed here.
        Data can be viewed in aggregate, by day or self-report status."
        />
      ) : (
        <div data-testid="widget-substance-use-loaded">
          <Grid container spacing={6}>
            <Grid item md={6}>
              <CravingChart
                showBupUseLabels={showBupUseLabels}
                dailySummaries={dailySummaries}
                onHoverCraving={onHoverCraving}
                onLeaveCraving={onLeaveCraving}
                timezone={timezone}
              />
            </Grid>
            <Grid item md={6}>
              <div className={styles['trigger-chart-container']}>
                <div className={styles.name}>Triggers</div>
                <div className={styles['chart-wrapper']}>
                  <TriggerChart triggers={triggersArray} />
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      )}
      <BlockBottom
        link={routes.PATIENT_DASHBOARD_CRAVINGS}
        text="Go To Cravings"
      />
    </WidgetWrapper>
  );
};

export default WidgetSubstanceUse;
